import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { formatMoneyInput } from "@/lib/formatters";

interface ThesisPriceAmountFieldProps {
  id: string;
  label: string;
  hint: string;
  value: string;
  onChange: (value: string) => void;
}

export function ThesisPriceAmountField({
  id,
  label,
  hint,
  value,
  onChange,
}: ThesisPriceAmountFieldProps) {
  const [focused, setFocused] = useState(false);

  return (
    <div className="space-y-1.5">
      <Label htmlFor={id}>{label}</Label>
      <div className="relative">
        <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm font-medium text-slate-500">
          ₦
        </span>
        <Input
          id={id}
          inputMode="decimal"
          autoComplete="off"
          className="pl-8 tabular-nums"
          value={focused ? formatMoneyInput(value) : settledCurrency(value)}
          onFocus={() => setFocused(true)}
          onBlur={() => {
            setFocused(false);
            onChange(normalizeCurrency(value));
          }}
          onChange={(event) => onChange(parseMoneyDraft(event.target.value))}
          placeholder="0.00"
        />
      </div>
      <p className="text-xs leading-5 text-slate-500">{hint}</p>
    </div>
  );
}

function settledCurrency(value: string): string {
  const amount = Number(value);
  if (!value.trim() || !Number.isFinite(amount)) return "";
  return formatMoneyInput(amount.toFixed(2));
}

function normalizeCurrency(value: string): string {
  const amount = Number(value);
  if (!value.trim() || !Number.isFinite(amount)) return "0.00";
  return amount.toFixed(2);
}

function parseMoneyDraft(value: string): string {
  const cleaned = value.replace(/,/g, "").replace(/[^\d.]/g, "");
  const dot = cleaned.indexOf(".");
  if (dot === -1) return cleaned;
  const fraction = cleaned
    .slice(dot + 1)
    .replace(/\./g, "")
    .slice(0, 2);
  return `${cleaned.slice(0, dot)}.${fraction}`;
}
